<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
         <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Care center</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="form.name" label="Name" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <g-input
                  :required="true"
                  id="address"
                  @change="setAddress"
                  @placechanged="setPlace"
                  :label="'Address'"
                  :clearable="true"
                  :delete="true"
                  :rules="itemRules"
                  :error="adress_notValid"
                ></g-input>
                <span v-if="adress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.tel" label="tel" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.email_address" label="Email" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
              <v-checkbox class="mt-3"
                color="primary"
                label="Visited"
                v-model="visited"
                @change="form.visited = visited"
              ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import gInput from '@/components/googlemaps/gInput';
  import FormMixin from '@/mixins/formvalid';
  export default {
    components: {
      'g-input': gInput
    },
    mixins: [FormMixin],
    props: ['dialog', 'form'],
    data () {
      return {
        valid: false,
        adress_notValid: false,
        menu: false,
        menu2: false,
        time: null,
        date: null,
        dateFormatted: null,
        items: [],
        visited: false

      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      save () {
        if (this.$refs.form.validate()) {
          if (this.form.address && this.form.zip && this.form.city) {
            this.$emit('save', this.form);
          } else {
            this.adress_notValid = true;
            console.log('check your address');
          }
        }
      },
      close () {
        this.$emit('close');
      },
      setAddress (v) {
        this.form.fullAddress = v;
      },
      setPlace (v) {
        if (v.street_number && v.postal_code && v.route && v.locality) {
          this.form.address = v.route + ' ' + v.street_number;
          this.form.zip = v.postal_code;
          this.form.city = v.locality || '';
          this.form.latitude = v.latitude;
          this.form.longitude = v.longitude;
          this.adress_notValid = false;
          console.log('is ok now');
        } else {
          console.log('is not ok');
          this.adress_notValid = true;
          this.form.fullAddress = this.form.address = this.form.zip = this.form.city = null;
        }
        console.log(v);
      },
      init (v) {
        if (v) {
          this.adress_notValid = false;
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    }
  }
</script>

